import { configureStore } from '@reduxjs/toolkit';
import { errorLoggingMiddleware } from 'store/middlewares/errorLogging.middleware';
import rootReducer from 'store/slices';
import * as Sentry from '@sentry/react';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  attachReduxState: false,
  actionTransformer: (action) => ({ type: action.type }),
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(errorLoggingMiddleware),
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(sentryReduxEnhancer),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
